import React, { useState, useEffect, useRef, useCallback} from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Box, Button } from '@mui/material';

const ImageResize = ({upImg, uploadFile}) => {

  const cropOptions ={
    width: 1366, height: 768, 
    // minWidth: 1366, minHeight: 768,  
    // maxWidth: 1366, maxHeight: 768, 
    // aspect: 16 / 9,
    
  }

  const imgRef = useRef(null);
  const [crop, setCrop] = useState({ ...cropOptions });
  const [completedCrop, setCompletedCrop] = useState(null);
  const previewCanvasRef = useRef(null);

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
  }, [completedCrop]);

  const uploadPhoto = () => {
    uploadFile(imgRef.current);
  }

  return (
    <Box>
      <Box sx={{minWidth: '1366px', minHeight: '768px'}}>
        <ReactCrop
          locked={true}
          // disabled={true}
          src={upImg}
          onImageLoaded={onLoad}
          crop={crop}
          onChange={(c) => setCrop(c)}
          onComplete={(c) => setCompletedCrop(c)}
        />
      </Box>
      <div>
        <canvas
          ref={previewCanvasRef}
          // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
          style={{
            width: Math.round(completedCrop?.width ?? 0),
            height: Math.round(completedCrop?.height ?? 0)
          }}
        />
      </div>
      <Button sx={{mt: 3}} variant="contained" onClick={uploadPhoto}> Upload </Button>
    </Box>
  );
}
 
export default React.memo(ImageResize);
